import { useMutation, useQueryClient } from '@tanstack/react-query'

import { queryKey as projectdossierQueryKey } from '../../../projectdossier/hooks/useProjectdossier'
import { useAlerts } from '../../../theme/hooks/useAlerts'
import { queryKey as hoofdleidingProjectenQueryKey } from '../../projecten/hooks/useProjectenSearch'
import { createProject } from '../services/createProject'

export { useCreateProject }

const useCreateProject = () => {
  const { successAlert, errorAlert } = useAlerts()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createProject,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [hoofdleidingProjectenQueryKey],
      })
      queryClient.invalidateQueries({
        queryKey: [projectdossierQueryKey],
      })
      successAlert('Project succesvol aangemaakt')
    },
    onError: (error: any) => {
      errorAlert('Fout bij aanmaken van project', error)
    },
  })
}
